import React, { FC, PropsWithChildren } from 'react'
import { useFormControlContext } from './_FormControlContext'
import s from './FormControl.module.scss'

interface Props {
  htmlFor?: string
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLLabelElement>, keyof Props>

export type FormControlCaptionProps = Props & NativeAttrs

const FormControlCaption: FC<PropsWithChildren<FormControlCaptionProps>> = ({
  children,
  htmlFor,
  ...props
}) => {
  const { disabled, id: formControlId, required } = useFormControlContext()

  return (
    <label className={s.caption} htmlFor={htmlFor || formControlId}>
      {children}
    </label>
  )
}

FormControlCaption.displayName = 'FormControlCaption'
export default FormControlCaption
